{
  "version": 1,
  "asset_id": "bbf32018-8be0-4b92-bc6d-241e0b197596",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/bbf32018-8be0-4b92-bc6d-241e0b197596/mark-96.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/bbf32018-8be0-4b92-bc6d-241e0b197596/mark-96.avif",
  "original_filename": "mark-96.avif",
  "size": 3844,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:18:37Z"
}
